import {ServiceBase} from "../service-base";
import {IFileSystemService} from "./file-system.service.interface";
import {IServiceFactory} from "../service-factory.interface";
import {HybridFileSystemStrategy} from "./strategies/hybrid-file-system.strategy";
import {WebappFileSystemStrategy} from "./strategies/webapp-file-system.strategy";

export class FileSystemService extends ServiceBase implements IFileSystemService {
    constructor(services: IServiceFactory) {
        super(services);

        if(this.services.device.isHybrid) {
            this._strategy = new HybridFileSystemStrategy();
        } else {
            this._strategy = new WebappFileSystemStrategy();
        }
    }

    private readonly _strategy: IFileSystemService;

    async saveBlob(blob: Blob, fileName: string): Promise<void> {
        await this._strategy.saveBlob(blob, fileName);
    }


}